export enum LocationKind {
  Load = 'load',
  Redirect = 'redirect',
  Push = 'push',
  Next = 'next',
  Back = 'back',
  Pop = 'pop',
}
